import { z } from 'zod';

// Contact Us Form Schema
export const contactUsFormSchema = z.object({
  enquiryType: z.string().min(1, 'Enquiry type is required'),
  fullName: z
    .string()
    .min(1, 'Full name is required')
    .max(100, 'Full name must not exceed 100 characters'),
  phoneNumber: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^(?:[+]?\d+(?:\s*\d+)*(?:-\d+)?)?$/, 'Invalid phone number'),
  emailAddress: z
    .string()
    .min(1, 'Email is required')
    .email('Invalid email address'),
  accountNumber: z.string().optional(),
  jobTitle: z.string().optional(),
  company: z.string().optional(),
  message: z.string().min(1, 'Message is required'),
  address: z.string().optional(),
});

export type ContactUsFormSchema = z.infer<typeof contactUsFormSchema>;
